var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('SideBar',{attrs:{"type":"sidebar"}}),_c('Notifications'),_c('TopNavbar'),_c('DashboardContent',{nativeOn:{"click":function($event){return _vm.toggleSidebar.apply(null, arguments)}}}),_c('ContentFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }